export function renderTerms(): string {
  const updated = "March 8, 2026";
  return `
    <div class="legal-page">
      <div class="container" style="max-width: 720px; padding: 60px 20px;">
        <h1 style="font-size: 2rem; font-weight: 700; color: #111827; margin-bottom: 8px;">Terms of Service</h1>
        <p style="color: #6b7280; margin-bottom: 48px;">Last updated: ${updated}</p>

        <div class="legal-section">
          <h2>1. Acceptance of terms</h2>
          <p>By creating an account or using SideScribe ("the Service"), you agree to these Terms of Service. If you do not agree, do not use the Service.</p>
        </div>

        <div class="legal-section">
          <h2>2. Description of service</h2>
          <p>SideScribe is a Microsoft Word add-in that uses AI language models (Claude, ChatGPT, Gemini) to provide writing feedback. The AI models are accessed via API keys that you supply. SideScribe does not provide AI model access — you must have your own account with Anthropic, OpenAI, or Google and agree to their respective terms of service.</p>
        </div>

        <div class="legal-section">
          <h2>3. Accounts</h2>
          <ul>
            <li>You must provide a valid email address and verify it to use the Service.</li>
            <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
            <li>You must be at least 13 years old to create an account.</li>
            <li>You may not share your account with others or create accounts on behalf of others without authorization.</li>
          </ul>
        </div>

        <div class="legal-section">
          <h2>4. Subscriptions and billing</h2>
          <ul>
            <li><strong>Free trial</strong> — new accounts include a 7-day free trial. No credit card is required to start the trial.</li>
            <li><strong>Paid plans</strong> — after the trial, a paid subscription ($3/month or $24/year) is required to continue using the add-in.</li>
            <li><strong>Billing</strong> — subscriptions are billed through Microsoft AppSource. Cancellation, refunds, and billing disputes are governed by Microsoft's marketplace policies.</li>
            <li><strong>API costs</strong> — your AI provider API usage is billed separately by OpenAI, Anthropic, or Google. SideScribe has no visibility into or control over those charges.</li>
          </ul>
        </div>

        <div class="legal-section">
          <h2>5. Acceptable use</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use the Service for any unlawful purpose or in violation of these terms.</li>
            <li>Attempt to reverse-engineer, decompile, or extract the source code of the Service.</li>
            <li>Use the Service to generate content that is illegal, harmful, harassing, defamatory, or otherwise objectionable.</li>
            <li>Circumvent any access controls, rate limits, or authentication mechanisms.</li>
            <li>Resell, sublicense, or redistribute access to the Service.</li>
          </ul>
        </div>

        <div class="legal-section">
          <h2>6. Your content and API keys</h2>
          <p>You retain all rights to your documents and writing. Text you submit for review is sent directly from your device to your chosen AI provider using your own API key — it does not pass through SideScribe servers. You are responsible for complying with your AI provider's usage policies when using their models through SideScribe.</p>
        </div>

        <div class="legal-section">
          <h2>7. Disclaimer of warranties</h2>
          <p>The Service is provided "as is" and "as available" without warranties of any kind, express or implied. SideScribe does not warrant that the AI suggestions provided are accurate, complete, or suitable for any particular purpose. AI-generated content may contain errors — always review suggestions before acting on them.</p>
        </div>

        <div class="legal-section">
          <h2>8. Limitation of liability</h2>
          <p>To the maximum extent permitted by law, SideScribe's total liability to you for any claims arising from your use of the Service is limited to the amount you paid for the Service in the 12 months preceding the claim. SideScribe is not liable for any indirect, incidental, special, consequential, or punitive damages.</p>
        </div>

        <div class="legal-section">
          <h2>9. Termination</h2>
          <p>You may cancel your subscription and delete your account at any time. We reserve the right to suspend or terminate accounts that violate these terms. Upon termination, your right to use the Service ends immediately.</p>
        </div>

        <div class="legal-section">
          <h2>10. Changes to these terms</h2>
          <p>We may update these terms from time to time. We will notify you of material changes by updating the "Last updated" date. Continued use of the Service after changes constitutes acceptance of the revised terms.</p>
        </div>

        <div class="legal-section">
          <h2>11. Governing law</h2>
          <p>These terms are governed by the laws of the United States. Any disputes shall be resolved in the courts of the United States.</p>
        </div>

        <div class="legal-section">
          <h2>12. Contact</h2>
          <p>Questions about these terms? Email us at <a href="mailto:support@sidescribe.ai">support@sidescribe.ai</a>.</p>
        </div>
      </div>
    </div>
  `;
}

export function mountTerms(): void {
  // No dynamic behavior needed
}
